import { pushSegmentAnalyticsTrack } from "utils/segment-analytics/push";

export function trackSegmentBooking(eventName, data) {
  pushSegmentAnalyticsTrack(eventName, data);
}
